import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/pinterest-p': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M204 6.5c94.2 0 180 64.8 180 164.1 0 93.3-47.7 196.8-153.9 196.8-25.2 0-57-12.6-69.3-36-22.8 90.3-21 103.8-71.4 172.8-5.2 1.9-3.5 2.3-6.9-1.5-1.8-18.9-4.5-37.5-4.5-56.4 0-61.2 28.2-149.7 42-209.1-7.5-15.3-9.6-33.9-9.6-50.7 0-80 93.9-92 93.9-25.8 0 39-26.4 75.6-26.4 113.4 0 25.8 21.3 43.8 46.2 43.8 69 0 90.3-99.6 90.3-152.7 0-71.1-50.4-109.8-118.5-109.8-79.2 0-140.4 57-140.4 137.4 0 38.7 23.7 58.5 23.7 67.8 0 7.8-5.7 35.4-15.6 35.4-24 0-63.6-40-63.6-110.4 0-110.7 101.4-179.1 204-179.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/pinterest-p.js
// module id = 970
// module chunks = 0